import { create } from 'zustand';
import { HedgePosition, DerivedHedgePosition } from '../../sp-types/positions';

type HedgePositionEntry = HedgePosition | DerivedHedgePosition;

interface IFinancialPositionStore {
  hedgePositions: HedgePositionEntry[];
  isFinancialPositionLoading: boolean;
  setIsFinancialPositionLoading: (_value: boolean) => void;
  setHedgePositions: (_value: HedgePositionEntry[]) => void;
  resetStore: () => void;
}

export const useFinancialPositionsStore = create<IFinancialPositionStore>((set) => ({
  hedgePositions: [],
  isFinancialPositionLoading: true,
  setIsFinancialPositionLoading: (value: boolean) => set({ isFinancialPositionLoading: value }),
  setHedgePositions: (hedgePositions: HedgePositionEntry[]) => set({ hedgePositions }),

  resetStore: () => set({ hedgePositions: [] }),
}));
